module.exports = __webpack_public_path__ + "img/Developer.6035f148.png";